// Global API connectivity tracker. useApi reports every fetch outcome here;
// the layout banner subscribes. Degraded = the most recent outcome anywhere
// was a failure — any later success from any page clears it. While degraded,
// /health is polled so the banner disappears as soon as the backend is back
// even if the user sits still.

const HEALTH_URL =
  (import.meta.env.VITE_API_BASE ?? "").replace(/\/$/, "") + "/api/v1/health";

let lastFailAt = 0;
let lastOkAt = 0;
let pollTimer: ReturnType<typeof setInterval> | null = null;
const listeners = new Set<(degraded: boolean) => void>();

export function apiDegraded(): boolean {
  return lastFailAt > lastOkAt;
}

function emit(): void {
  const d = apiDegraded();
  listeners.forEach((fn) => fn(d));
  if (d && !pollTimer) {
    pollTimer = setInterval(() => {
      fetch(HEALTH_URL, { headers: { Accept: "application/json" } })
        .then((r) => { if (r.ok) markApiOk(); })
        .catch(() => {});
    }, 10_000);
  }
  if (!d && pollTimer) {
    clearInterval(pollTimer);
    pollTimer = null;
  }
}

export function markApiOk(): void {
  lastOkAt = Date.now();
  emit();
}

export function markApiFail(): void {
  lastFailAt = Date.now();
  emit();
}

export function subscribeApiHealth(fn: (degraded: boolean) => void): () => void {
  listeners.add(fn);
  fn(apiDegraded());
  return () => {
    listeners.delete(fn);
  };
}
